import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { FormGroup, Label } from "reactstrap";
import {
  DC_COMPANY,
  DC_KUARTAL,
  DC_REPORT_TYPE,
  DC_YEAR,
} from "../../constants";
import {
  SelectPerusahaanComponent,
  DocumentTypes,
  YearList,
  KuartalComponent,
} from "../../component/Utils";
export default () => {
  const dispatch = useDispatch();
  const { company, reportType, year, kuartal } = useSelector(
    (state) => state.documentReportReducer
  );
  const companies = useSelector(
    (state) => state.perusahaanReducer.listPerusahaan
  );
  React.useEffect(() => {
    const data = {
      id: companies?.content[0]?.id,
      name: companies?.content[0]?.nama,
    };
    dispatch({ type: DC_COMPANY, data });
  }, [companies]);
  const onChange = (type, data) => {
    if (type === DC_COMPANY) {
      data = {
        id: data,
        name: companies.content.filter((c) => c.id === data)?.nama,
      };
    }
    dispatch({ type, data });
  };
  return (
    <>
      <FormGroup className="mr-md-3">
        <Label>Perusahaan</Label>
        <SelectPerusahaanComponent
          value={company}
          onChange={(e, { value }) => onChange(DC_COMPANY, value)}
          className="form-control"
        />
      </FormGroup>
      <FormGroup>
        <Label for="reportType">Jenis Laporan</Label>
        <DocumentTypes
          value={reportType}
          onChange={(e, { value }) => onChange(DC_REPORT_TYPE, value)}
          className="form-control"
        />
      </FormGroup>
      <FormGroup>
        <Label for="year">Tahun</Label>
        <YearList
          value={year}
          onChange={(e, { value }) => onChange(DC_YEAR, value)}
          className="form-control"
        />
      </FormGroup>
      <FormGroup>
        <Label for="period">Periode</Label>
        <KuartalComponent
          value={kuartal}
          onChange={(e, { value }) => onChange(DC_KUARTAL, value)}
          className="form-control"
        />
      </FormGroup>
    </>
  );
};
